<template>
<!--  <div>-->
<!--    <user-form :is-edit="false" />-->
<!--  </div>-->
  <is-admin>
    <div class="mt-5">
      <users-view-table :users="users" />
    </div>
  </is-admin>

</template>

<script>
import UserForm from "@/components/Users/UserForm";
import UsersTable from "@/components/ClientDetails/UsersTable";
import UsersViewTable from "@/components/Users/UsersViewTable";
import EditUserWindow from "@/components/Users/EditUserWindow";
import IsAdmin from "@/components/Authorization/IsAdmin";
export default {
  name: "Users",
  components: {IsAdmin, EditUserWindow, UsersViewTable, UsersTable, UserForm},
  async mounted() {
      this.$store.dispatch('showLoadingSpinner')
      try {
        await this.$store.dispatch('getUsers')
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
    }
    this.$store.dispatch('hideLoadingSpinner')

  },

  methods: {},

  computed: {
    users() {
      return this.$store.getters.getUsers
    },
    userRole() {
      return this.$store.getters.getGravyUserRole
    }
  }
}
</script>

<style scoped>

</style>